(()=>{
  const q=(s,c=document)=>c.querySelector(s);
  const qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const body=document.body;

  const drawer=q('[data-menu-drawer]');
  const overlay=q('.drawer-overlay');
  function menu(open){
    drawer?.classList.toggle('open',open);
    overlay?.classList.toggle('open',open);
    body.classList.toggle('no-scroll',open);
  }
  q('[data-menu-toggle]')?.addEventListener('click',()=>menu(true));
  qa('[data-menu-close]').forEach(x=>x.addEventListener('click',()=>menu(false)));

  const search=q('[data-search-overlay]');
  const searchInput=q('[data-search-input]');
  const results=q('[data-search-results]');
  function toggleSearch(open){
    search?.classList.toggle('open',open);
    search?.setAttribute('aria-hidden',String(!open));
    body.classList.toggle('no-scroll',open);
    if(open)setTimeout(()=>searchInput?.focus(),50);
  }
  q('[data-search-open]')?.addEventListener('click',()=>toggleSearch(true));
  q('[data-search-close]')?.addEventListener('click',()=>toggleSearch(false));
  search?.addEventListener('click',event=>{if(event.target===search)toggleSearch(false)});

  let searchTimer;
  searchInput?.addEventListener('input',()=>{
    clearTimeout(searchTimer);
    const term=searchInput.value.trim();
    if(term.length<2){
      results.innerHTML='<p>Type at least 2 characters.</p>';
      return;
    }
    searchTimer=setTimeout(async()=>{
      try{
        const response=await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`);
        const json=await response.json();
        const products=json.resources?.results?.products||[];
        results.innerHTML=products.length
          ?products.map(product=>`<a class="search-result-row" href="${product.url}">${product.image?`<img src="${product.image}" alt="">`:''}<span><b>${product.title}</b><small>${product.vendor||''}</small></span><strong>${product.price||''}</strong></a>`).join('')
          :'<p>No products found.</p>';
      }catch(error){
        results.innerHTML='<p>Search is temporarily unavailable.</p>';
      }
    },220);
  });

  // Rapi Cart integration:
  // Do not prevent the native product-form submit and do not open the theme's old cart drawer.
  // The enabled Rapi app embed listens for Shopify cart actions and renders its own drawer.
  const formatMoney=value=>{
    const currency=window.Shopify?.currency?.active||'INR';
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency}).format(value/100);
    }catch(error){
      return `${(value/100).toFixed(2)} ${currency}`;
    }
  };

  async function refreshCartBadges(){
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});
      if(!response.ok)return;
      const cart=await response.json();
      qa('[data-cart-count],.cart-count,.mobile-cart-count,[data-cart-count-inline]').forEach(element=>{
        element.textContent=cart.item_count;
        element.classList.toggle('is-empty',cart.item_count===0);
      });
      qa('[data-cart-total-display]').forEach(element=>{element.textContent=formatMoney(cart.total_price)});
    }catch(error){
      // Cart links still fall back to Shopify's /cart page if the app is unavailable.
    }
  }

  function scheduleCartRefresh(){
    [400,1200].forEach(delay=>setTimeout(refreshCartBadges,delay));
  }

  document.addEventListener('submit',event=>{
    if(event.target.closest('form[action*="/cart/add"]'))scheduleCartRefresh();
  },true);

  ['cart:updated','cart:refresh','cart:change','rapi:cart:updated','rapi-cart:updated'].forEach(eventName=>{
    document.addEventListener(eventName,refreshCartBadges);
  });

  qa('[data-rapi-cart-link]').forEach(link=>{
    link.addEventListener('click',()=>setTimeout(refreshCartBadges,250));
  });

  q('[data-sort-by]')?.addEventListener('change',event=>{
    const url=new URL(location.href);
    url.searchParams.set('sort_by',event.target.value);
    location.href=url;
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'){
      toggleSearch(false);
      menu(false);
    }
  });

  refreshCartBadges();
})();

/* Advanced cart quantity controls */
document.addEventListener('click',event=>{
  const minus=event.target.closest('[data-quantity-minus]');
  const plus=event.target.closest('[data-quantity-plus]');
  if(!minus&&!plus)return;
  const wrap=event.target.closest('[data-quantity-wrap]');
  const input=wrap?.querySelector('input[type="number"]');
  if(!input)return;
  const current=Number(input.value)||0;
  const min=input.min===''?0:Number(input.min);
  const max=input.max===''?Infinity:Number(input.max);
  input.value=String(Math.min(max,Math.max(min,current+(plus?1:-1))));
  input.dispatchEvent(new Event('change',{bubbles:true}));
});


/* Digi Mart advanced product page */
document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('[data-product-section]');
  if(!section)return;
  const one=(s,c=section)=>c.querySelector(s), all=(s,c=section)=>[...c.querySelectorAll(s)];
  const main=one('#ProductMainImage');
  all('[data-thumb]').forEach(btn=>btn.addEventListener('click',()=>{if(main){main.src=btn.dataset.thumb;main.srcset=''}all('[data-thumb]').forEach(x=>x.classList.remove('active'));btn.classList.add('active')}));
  const select=one('[data-variant-select]');
  const update=()=>{if(!select)return;const o=select.selectedOptions[0],price=one('[data-product-price]'),compare=one('[data-compare-price]'),discount=one('[data-discount]'),stock=one('[data-stock-status]'),add=one('button[name="add"]'),label=one('[data-add-label]'),sticky=document.querySelector('[data-sticky-add]'),stickyPrice=document.querySelector('[data-sticky-price]');const p=Number(o.dataset.priceRaw||0),c=Number(o.dataset.compareRaw||0),available=o.dataset.available==='true',inventory=Number(o.dataset.inventory||0),sku=one('[data-product-sku-text]');if(price)price.textContent=o.dataset.price;if(sku)sku.textContent=o.dataset.sku||'';if(stickyPrice)stickyPrice.textContent=o.dataset.price;if(c>p){compare.hidden=false;compare.textContent=o.dataset.compare;discount.hidden=false;discount.textContent=Math.round((c-p)*100/c)+'% OFF'}else{compare.hidden=true;discount.hidden=true}if(stock){stock.classList.toggle('is-sold-out',!available);stock.textContent=available?(o.dataset.managed&&inventory>0&&inventory<=10?'🔥 Only '+inventory+' left':'● In stock · Ready to dispatch'):'● Currently unavailable'}if(add){add.disabled=!available;if(label)label.textContent=available?'Add to Cart':'Sold Out'}if(sticky){sticky.disabled=!available;sticky.textContent=available?'Add to Cart':'Sold Out'}if(main&&o.dataset.image){main.src=o.dataset.image;main.srcset=''}history.replaceState({},'',location.pathname+'?variant='+o.value)};
  select?.addEventListener('change',update);
  all('[data-variant-button]').forEach(button=>button.addEventListener('click',()=>{
    if(!select||button.disabled)return;
    select.value=button.dataset.variantButton;
    all('[data-variant-button]').forEach(item=>{
      const selected=item===button;
      item.classList.toggle('is-selected',selected);
      item.setAttribute('aria-pressed',String(selected));
    });
    select.dispatchEvent(new Event('change',{bubbles:true}));
  }));
  one('[data-pincode-check]')?.addEventListener('click',()=>{const input=one('.pincode-box input'),result=one('[data-pincode-result]'),valid=/^[1-9][0-9]{5}$/.test(input?.value||'');result.textContent=valid?'Estimated delivery: 5–8 business days after dispatch. COD is confirmed at checkout.':'Please enter a valid 6-digit Indian PIN code.';result.style.color=valid?'#15803d':'#b91c1c'});
  document.querySelector('[data-sticky-add]')?.addEventListener('click',()=>one('.product-form button[name="add"]')?.click());
});

/* Reference-style sticky product purchase bar */
document.addEventListener('DOMContentLoaded',()=>{
  const section=document.querySelector('[data-product-section]');
  const bar=document.querySelector('[data-bottom-buybar]');
  if(!section||!bar)return;
  const mainForm=section.querySelector('.product-form');
  const mainSelect=section.querySelector('[data-variant-select]');
  const bottomSelect=bar.querySelector('[data-bottom-variant]');
  const bottomPrice=bar.querySelector('[data-bottom-price]');
  const bottomAdd=bar.querySelector('.dm-bottom-add');
  const bottomLabel=bar.querySelector('[data-bottom-add-label]');
  const mainQty=mainForm?.querySelector('input[name="quantity"]');
  const bottomQty=bar.querySelector('[data-bottom-qty]');
  const mainActions=section.querySelector('.dm-product-actions');

  const desktopQuery=window.matchMedia('(min-width: 921px)');
  let actionsObserver;
  const setupBarVisibility=()=>{
    actionsObserver?.disconnect();
    bar.classList.remove('is-visible');
    if(!desktopQuery.matches||!mainActions)return;
    actionsObserver=new IntersectionObserver(entries=>{
      bar.classList.toggle('is-visible',!entries[0].isIntersecting);
    },{threshold:0});
    actionsObserver.observe(mainActions);
  };
  setupBarVisibility();
  desktopQuery.addEventListener?.('change',setupBarVisibility);

  const syncBottom=()=>{
    const option=mainSelect?.selectedOptions?.[0];
    if(!option)return;
    if(bottomSelect)bottomSelect.value=option.value;
    if(bottomPrice)bottomPrice.textContent=option.dataset.price||'';
    const available=option.dataset.available==='true';
    if(bottomAdd)bottomAdd.disabled=!available;
    if(bottomLabel)bottomLabel.textContent=available?'Add to Cart':'Sold Out';
  };
  mainSelect?.addEventListener('change',syncBottom);
  syncBottom();

  bottomSelect?.addEventListener('change',()=>{
    if(!mainSelect)return;
    mainSelect.value=bottomSelect.value;
    mainSelect.dispatchEvent(new Event('change',{bubbles:true}));
    const selectedButton=section.querySelector(`[data-variant-button="${CSS.escape(bottomSelect.value)}"]`);
    section.querySelectorAll('[data-variant-button]').forEach(btn=>{
      const selected=btn===selectedButton;
      btn.classList.toggle('is-selected',selected);
      btn.setAttribute('aria-pressed',String(selected));
    });
  });

  bar.querySelector('[data-bottom-minus]')?.addEventListener('click',()=>{bottomQty.value=String(Math.max(1,(Number(bottomQty.value)||1)-1));if(mainQty)mainQty.value=bottomQty.value});
  bar.querySelector('[data-bottom-plus]')?.addEventListener('click',()=>{bottomQty.value=String((Number(bottomQty.value)||1)+1);if(mainQty)mainQty.value=bottomQty.value});
  bottomQty?.addEventListener('change',()=>{bottomQty.value=String(Math.max(1,Number(bottomQty.value)||1));if(mainQty)mainQty.value=bottomQty.value});
  mainQty?.addEventListener('change',()=>{if(bottomQty)bottomQty.value=mainQty.value});
});
